import React, 
       { useState, 
         useEffect, 
         useRef, 
         useCallback }                      from "react";
import { useLoader}                         from "components/Covers/loadingCover";
import { useActionModal}                    from "components/Covers/confirmAction";
import { useInfoMsgModal}                   from "components/Covers/infoMessageModal";
import { InputGeneral}                      from "components/Field/field";
import { DatePicker,
         DateTimePicker,
         DateToIsoString,
         DateFromIsoString,
         InitDateToIsoString,
         InitDateFromIsoString,
         FinDateToIsoString,
         FinDateFromIsoString,
         setDefaultInitDate,
         setDefaultFinalDate,
         compareInitFinDate }               from "components/Date/date";
import  MainStyle                           from "components/UI/main.module.scss";
import { getOrdersList }                    from "./orderReadyService";
import { useNavigate   }                    from "react-router-dom";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import { Select }                           from "antd";
import { useFilter }                        from "components/Menu/menu";
import { DefaultLoadingLogo,
         getFileTmpSrc,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature,
         toSafeFilename }                   from "Utilities/utils";
import {DisplayGridDatetime}                from "components/Date/date";
import dayjs                                from "dayjs";
import { useToastMessage }                  from "components/Covers/toastMessage";

// #region Object Template
let blank_order_obj = {
    ORDER_ID               :    0           ,
    STATUS_ID              :    3           ,
    SCHOOL_ID              :    0           ,
    AREA_ID                :    0           ,
    CLIENT_ID              :    0           ,
    PROGRAM_ID             :    0           ,
    COLOR                  :    0           ,
    QRCODE                 :    0           ,
    QRCODE_DATA            :    ""          ,
    QRCODEP                :    0           ,
    QRCODEP_DATA           :    ""          ,
    PPT_TEMPLATE           :    0           ,
    PPT                    :    0           ,
    PPT_DATA               :    ""          ,
    PPT_FOOTER             :    0           ,
    LOGO1                  :    0           ,
    LOGO2                  :    0           ,
    LOGO3                  :    0           ,
    ORDER_CODE             :    ""          ,
    ORDER_DESC             :    ""          ,
    CLASS                  :    ""          ,
    OPENING                :    DateToIsoString(setDefaultInitDate()),  
    CLOSING                :    DateToIsoString(setDefaultFinalDate()), 
    LANG_PT                :    "Y"         , 
    LANG_EN                :    "N"         , 
    LANG_ES                :    "N"         , 
    OBSERVATIONS           :    "Y"         , 
    HEADER_LANG_PT_DESC_1  :    ""          ,
    HEADER_LANG_PT_DESC_2  :    ""          ,
    HEADER_LANG_PT_DESC_3  :    ""          ,
    HEADER_LANG_PT_DESC_4  :    ""          ,
    HEADER_LANG_EN_DESC_1  :    ""          ,
    HEADER_LANG_EN_DESC_2  :    ""          ,
    HEADER_LANG_EN_DESC_3  :    ""          ,
    HEADER_LANG_EN_DESC_4  :    ""          ,
    HEADER_LANG_ES_DESC_1  :    ""          ,
    HEADER_LANG_ES_DESC_2  :    ""          ,
    HEADER_LANG_ES_DESC_3  :    ""          ,
    HEADER_LANG_ES_DESC_4  :    ""          ,
    EXPLAN_LANG            :    "N"         , 
    EXPLAN_LANG_PT_DESC    :    ""          ,
    EXPLAN_LANG_EN_DESC    :    ""          ,
    EXPLAN_LANG_ES_DESC    :    ""          ,
    SUBTI_LANG             :    "N"         , 
    SUBTI_LANG_PT_DESC     :    ""          ,
    SUBTI_LANG_EN_DESC     :    ""          ,
    SUBTI_LANG_ES_DESC     :    ""          ,
    SESSIONS               :    []          , 
    USERS                  :    []
};
let blank_search_param_obj = {
    STATUS_ID:          [4],
    DT_INIT:            DateToIsoString(setDefaultInitDate()),
    DT_FN:              DateToIsoString(setDefaultFinalDate())
};
let appLang = null;
// #endregion

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_lg, MainStyle.border_bottom].join(" ")}/>
                </div>
            </div>
        </>
    );
};
//#endregion

const FilterOptions = React.memo(({...props}) => {
    const { showInfoMessage }      = useInfoMsgModal();
    const { showLoader, 
            hideLoader      }      = useLoader();
    const { setRowData      }      = props;
    const [ searchParam, 
            setSearchParam  ]      = useState(blank_search_param_obj);


    async function startSearch() {
        if (!compareInitFinDate(searchParam.DT_INIT, searchParam.DT_FN)) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230) });
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
        let data = await getOrdersList(searchParam);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                let arr = [];
                for(var j = 0; j < data.length; j++) {
                    arr.push(data[j]);
                }
                setRowData(arr);
                hideLoader();
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
    }

    return(
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                            {GetLabel(appLang, 487)}
                        </span>                      
                        <DatePicker
                            value={InitDateFromIsoString(searchParam.DT_INIT)}
                            placeholder={GetLabel(appLang, 487)}
                            style={{ width: "100%" }}
                            className={[MainStyle.mt_2].join(" ")}
                            onChange={(date) => {
                                setSearchParam(prev => {
                                    return({
                                        ...prev,
                                        DT_INIT: InitDateToIsoString(date),
                                    });
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                            {GetLabel(appLang, 488)}
                        </span>
                        <DatePicker
                            value={DateFromIsoString(searchParam.DT_FN)}
                            placeholder={GetLabel(appLang, 488)}
                            style={{ width: "100%" }}
                            className={[MainStyle.mt_2].join(" ")}
                            onChange={(date) => {
                                setSearchParam(prev => {
                                    return({
                                        ...prev,
                                        DT_FN: InitDateToIsoString(date),
                                    });
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_green, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {startSearch();}}
                        >
                            {GetLabel(appLang, 238)}
                        </button>
                    </div>
                </div>                            
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {
                                 setSearchParam(prev => {
                                    return({
                                        ...prev,
                                        DT_INIT: DateToIsoString(setDefaultInitDate()),
                                        DT_FN: DateToIsoString(setDefaultFinalDate()),
                                        STATUS_ID: prev.STATUS_ID.map((status, i) =>
                                            i === 0 ?
                                                3
                                            :
                                                status
                                        )

                                    });
                                });
                            }}
                        >
                            {GetLabel(appLang, 239)}
                        </button>
                    </div>
                </div>                            
            </div>
        </>
    );

});

const OrderTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading   ] = useState(false);   // Loading fetch control
    const { showLoader, hideLoader     } = useLoader();       // Control over the  
    const [searchText,  setSearchText  ] = useState('');      // Searched text state
    const [rowData,     setRowData     ] = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs  ] = useState([]);      // State of columns def
    const gridRef                        = useRef();
    const { showInfoMessage            } = useInfoMsgModal(); // Modal message control 
    const { showFilter, hideFilter     } = useFilter();       // Control over the loader
    const { showToastMessage           } = useToastMessage();   // Toast message display
    const navigate                       = useNavigate();

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const ViewItem = (props) => {
        const handleData = async () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_order_obj));
            obj_copy.ORDER_ID = props.data.ORDER_ID;
            hideFilter();
            navigate(`/orders_ready/${obj_copy.ORDER_ID}/p`);
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 576 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
                    </svg>
                </div>
            </>
        );
    };

    const ViewByCode = (props) => {
        return(
            <>
                <span   style={{cursor: 'pointer'}}
                        className={[ MainStyle.text_body, MainStyle.text_decoration_underline].join(" ")} 
                        onClick={() => {navigate(`/s/${props.data.ORDER_CODE}`);}}
                >
                    {`${window.location.origin}/s/${props.data.ORDER_CODE}`}
                </span>
            </>
        );
    };

    const CopyPath = (props) => {
        return(
            <div 
                onClick={() => {                    
                    navigator.clipboard.writeText(`${window.location.origin}/s/${props.data.ORDER_CODE}`);
                    showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 502) });
                }}
                className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 448 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
                >
                    <path d="M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"/>
                </svg>
            </div>
        );
    };

    const DownLoadFileItem = (props) => {
        return(
            <>
                <a  href={getFileTmpSrc(props.value)} download={`${toSafeFilename(props.data.ORDER_DESC)}.pptx`}>
                    <div className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 512 512"
                            className={[MainStyle.small_ico_generic].join(" ")}
                        >
                            <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                        </svg>
                    </div>
                </a>
            </>
        );
    };

    const DateLabel = ({...other}) => {
        const { status, dt0, dt1 } = other;
        let c = dayjs();
        let i = DateFromIsoString(dt0);
        let f = DateFromIsoString(dt1);
        let style = [MainStyle.border, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center, MainStyle.rounded_3];
        let label = "";
        if (status === 5) {
            style.push(MainStyle.bg_success, MainStyle.text_white);
            label = GetLabel(appLang, 97);
        }
        else {
            if ((c > i) && (c < f)) {
                style.push(MainStyle.bg_warning, MainStyle.text_black);
                label = GetLabel(appLang, 40);
            }
            else if ((c > i) && (c > f)) {
                style.push(MainStyle.bg_success, MainStyle.text_white);
                label = GetLabel(appLang, 98);
            }
            else {
                style.push(MainStyle.bg_success, MainStyle.text_white);
                label = GetLabel(appLang, 99);
            }
        }
        return (
            <div style={{width: '5.0rem'}} className={style.join(" ")}>
                <span className={[MainStyle.fs_7, MainStyle.p_1].join(" ")}>
                    {label}
                </span>
            </div>
        );
    };

    const defaultCol = [
        {
            headerName: GetLabel(appLang, 571),
            marryChildren: true,
            children: [
                DavidCopperfield(13,89,2) && {
                    headerName: GetLabel(appLang, 489),
                    field: 'show',
                    cellRenderer: ViewItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },
                DavidCopperfield(13,89,2) && {
                    headerName: GetLabel(appLang, 499),
                    field: 'PPT_DATA',
                    cellRenderer: DownLoadFileItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },
                {
                    headerName: GetLabel(appLang, 501),
                    field: 'ORDER_CODE',
                    cellRenderer: CopyPath,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },   
            ]
        },
        {
            headerName: GetLabel(appLang, 572),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 34),   field: "ORDER_ID"     ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,                    
                DavidCopperfield(13,89,2) && {
                    columnGroupShow: 'open',
                    headerName: GetLabel(appLang, 500),
                    field: 'ORDER_CODE',
                    cellRenderer: ViewByCode,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
                { headerName: GetLabel(appLang, 36),     field: "ORDER_DESC"   ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                                
                {
                    headerName: GetLabel(appLang, 37),
                    field: 'OPENING',
                    filter: true,
                    flex: 0,
                    cellRenderer: (params) => {
                        return (
                        <DateLabel
                            status={params.data?.STATUS_ID}
                            dt0={params.data?.OPENING}
                            dt1={params.data?.CLOSING}
                        />
                        );
                    },
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },                
            ]
        },
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 318),    field: "SCHOOL_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 319),    field: "AREA_DESC"    ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 321),    field: "PROGRAM_DESC" ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 322),    field: "CLIENT_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 564),    field: "CLASS"        ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
            ]
        },
        {
            headerName: GetLabel(appLang, 574),
            marryChildren: true,
            children: [
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 493),    field: "AUTHOR"       ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 117),    field: "CREATED"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 38),     field: "OPENING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 39),     field: "CLOSING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
            ]
        }                               
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        showFilter({jsx: <FilterOptions setRowData={setRowData} />});
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                let data = await getOrdersList({STATUS_ID: [4],
                                                DT_INIT: '1970-01-01 00:00:00',
                                                DT_FN: '2050-12-31 23:59:59'});
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <DefaultPadding/>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const OrderReadyPage = () => {
    const [ screenType,         setScreenType       ]   = useState(1);
    const [ defaultData,        setDefaultData      ]   = useState({});
    const { showActionMessage                       }   = useActionModal();
    const navigate                                      = useNavigate();  

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([13])) {
            navigate('/home');
        }
        else {
            SetLastFeature(13);
        }            
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 70)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3].join(" ")}>
                        <OrderTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <DefaultPadding/>
        </>
        : null
        }
        </>
    );
};